export default __webpack_public_path__ + "static/media/womens_diamond_band.34920253.webp";